const attachment = {
  id: '544f947c-390b-4200-b599-d60b3a5bd46e',
  contentType: 'application/vnd.microsoft.card.adaptive',
  name: null,
  thumbnailUrl: null,
  contentUrl: null,
  content: JSON.stringify({
    type: 'AdaptiveCard',
    $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
    version: '1.4',
    body: [
      {
        type: 'ColumnSet',
        columns: [
          {
            type: 'Column',
            width: 1,
            items: [
              {
                type: 'TextBlock',
                text: '{{CONTENT_TITLE}}',
                wrap: true,
                fontType: 'Default',
                size: 'Large',
                weight: 'Bolder'
              },
              {
                type: 'TextBlock',
                text: 'Unsure what to send? How about:',
                wrap: true
              },
              {
                type: 'TextBlock',
                text: '[[INPUT_SHARE_TEXT]]',
                wrap: true
              }
            ]
          }
        ]
      }
    ],
    actions: [
      {
        type: 'Action.OpenUrl',
        url: '{{CONTENT_LINKEDIN_SHARE_LINK}}',
        title: '',
        iconUrl: 'https://real-links-assets-dev.s3-eu-west-2.amazonaws.com/real-links-WK80K/2023-12-06/01HGZ9V1JDSNHZZFC59WDMAYXS/screenshot-2023-12-06-at-11-07-22.png'
      },
      {
        type: 'Action.OpenUrl',
        url: '{{CONTENT_FACEBOOK_SHARE_LINK}}',
        title: '',
        iconUrl: 'https://real-links-assets-dev.s3-eu-west-2.amazonaws.com/real-links-WK80K/2023-12-06/01HGZ9TB37H32GAE5NASXE0D0B/screenshot-2023-12-06-at-11-07-51.png'
      },
      {
        type: 'Action.OpenUrl',
        title: '',
        url: '{{CONTENT_TWITTER_SHARE_LINK}}',
        iconUrl: 'https://real-links-assets-dev.s3-eu-west-2.amazonaws.com/real-links-WK80K/2023-12-06/01HGZ9R90RSYJRHZRNYESWQF1T/screenshot-2023-12-06-at-11-09-30.png'
      },
      {
        type: 'Action.OpenUrl',
        title: '',
        iconUrl: 'https://real-links-assets-dev.s3-eu-west-2.amazonaws.com/real-links-WK80K/2023-12-06/01HGZ9S0KG7J7JD19H7HX44ZND/screenshot-2023-12-06-at-11-08-18.png',
        url: '{{CONTENT_WHATSAPP_SHARE_LINK}}'
      }
    ]
  })
};

export default {
  id: 'teams_promote_content',
  title: 'Promote content',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'CONTENT' ],
  description: 'Send a selected piece of content to your employees so they can easily share it across their network.',
  body: {
    attachments: [ attachment ],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_INTRODUCTION_TEXT]]</p>
        <attachment id='${attachment.id}'></attachment>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following content with your network to win rewards! ...',
      defaultValue: 'Share the following content with your network to win rewards!',
      type: 'HTML'
    },
    INPUT_SHARE_TEXT: {
      label: 'Share Text',
      placeholder: 'Checkout the following page...',
      defaultValue: 'Checkout the following page {{CONTENT_TITLE}}',
      type: 'TEXTAREA'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/promoteContent.js